import React from "react";

// EXTRAS

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { grey } from "@mui/material/colors";
import { TypographyBoldOnPrint } from "../styled";
import { formatFinance } from "../../utils/formatters";

export default function OrderTicketValuesInfos({
  observations,
  sub_total,
  delivery_tax,
  voucher_discount,
  serviceFeeAmount,
  tax,
  total,
  orderType,
}) {
  const calculateOrderTotal = () => {
    return formatFinance(parseFloat(total));
  };

  return (
    <Box>
      <TypographyBoldOnPrint
        variant="body2"
        align="center"
        fontWeight="bold"
        color={grey["900"]}
      >
        VALORES
      </TypographyBoldOnPrint>
      {observations && (
        <TypographyBoldOnPrint
          variant="body2"
          fontWeight="bold"
          color={grey["900"]}
          gutterBottom
        >
          OBS: {observations}
        </TypographyBoldOnPrint>
      )}
      {/*<Stack direction="row" justifyContent="space-between">*/}
      {/*  <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*    Itens:*/}
      {/*  </TypographyBoldOnPrint>*/}
      {/*  <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*    {formatFinance(parseFloat(sub_total ?? 0))}*/}
      {/*  </TypographyBoldOnPrint>*/}
      {/*</Stack>*/}
      {/*{orderType === "DELIVERY" && (*/}
      {/*  <Stack direction="row" justifyContent="space-between">*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      Entrega:*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      {formatFinance(parseFloat(delivery_tax ?? 0))}*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*  </Stack>*/}
      {/*)}*/}
      {/*{voucher_discount > 0 && (*/}
      {/*  <Stack direction="row" justifyContent="space-between">*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      Descontos:*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      {formatFinance(parseFloat(voucher_discount ?? 0))}*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*  </Stack>*/}
      {/*)}*/}
      {/*{serviceFeeAmount > 0 && (*/}
      {/*  <Stack direction="row" justifyContent="space-between">*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      Taxa de Serviço:*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      {formatFinance(parseFloat(serviceFeeAmount ?? 0))}*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*  </Stack>*/}
      {/*)}*/}
      {/*{tax > 0 && (*/}
      {/*  <Stack direction="row" justifyContent="space-between">*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      Adicional:*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*    <TypographyBoldOnPrint variant="body2" color={grey["900"]}>*/}
      {/*      {formatFinance(parseFloat(tax ?? 0))}*/}
      {/*    </TypographyBoldOnPrint>*/}
      {/*  </Stack>*/}
      {/*)}*/}
      <Stack direction="row" justifyContent="space-between">
        <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
          Total:
        </TypographyBoldOnPrint>
        <TypographyBoldOnPrint variant="body2" color={grey["900"]}>
          {calculateOrderTotal()}
        </TypographyBoldOnPrint>
      </Stack>
    </Box>
  );
}
